import styled from "styled-components";

export const StyledEmpty = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  height: 100%;
  padding: var(--spacing-lg) var(--spacing-sm);
  gap: var(--spacing-sm);
  text-align: center;
  color: var(--color-text);
  h3 {
    font-size: var(--font-size-lg);
    font-weight: 600;
  }
  p {
    font-size: var(--font-size-md);
    font-weight: 400;
  }
`;
